import React from 'react';
import PropTypes from 'prop-types';

import SimpleButton from 'styled/Buttons/SimpleButton';

import IconAccepted from 'icons/Accepted';
import IconRejected from 'icons/Rejected';

import MaterialCardModal from 'admin-moderator/components/MaterialCardModal';
import MediaFile from 'admin-moderator/components/MediaFile';

import MaterialCardStyled from './MaterialCardStyled';
import Footer from './Footer';

export class MaterialCard extends React.PureComponent {
  state = {
    loading: false,
    isOpenModalMessage: false,
  };

  handleAcceptClick = () => {
    this.handleStatusChange({ status: 'accepted' });
  };

  handleRejectClick = () => {
    this.setState({ isOpenModalMessage: true });
  };

  handleModalCloseClick = () => {
    this.setState({ isOpenModalMessage: false });
  };

  handleModalButtonClick = (statusMessage) => {
    this.setState({ isOpenModalMessage: false });
    this.handleStatusChange({ status: 'rejected', explain: statusMessage });
  };

  handleStatusChange = ({ status, explain = '' }) => {
    this.props.onStatusChange({ status, explain });
  }

  render() {
    return (
      <MaterialCardStyled>
        <MaterialCardModal
          onClose={this.handleModalCloseClick}
          onClick={this.handleModalButtonClick}
          isOpen={this.state.isOpenModalMessage}
        />

        <MediaFile
          key={this.props.url}

          mediaType={this.props.mediaType}
          url={this.props.url}
          cover={this.props.cover}
          originalUrl={this.props.originalUrl}
          title={this.props.title}
          loading={this.props.loading}
          videoStatus={this.props.videoStatus}
        />

        <Footer>
          <SimpleButton
            onClick={this.handleAcceptClick}
            disabled={this.props.loading || this.state.loading || this.props.status === 'accepted'}
          >
            <IconAccepted />
          </SimpleButton>

          <SimpleButton
            onClick={this.handleRejectClick}
            disabled={this.props.loading || this.state.loading || this.props.status === 'rejected'}
            style={{ marginLeft: '30px' }}
          >
            <IconRejected />
          </SimpleButton>
        </Footer>
      </MaterialCardStyled>
    );
  }
}

MaterialCard.propTypes = {
  mediaType: PropTypes.oneOf(['image', 'video']),
  cover: PropTypes.string,
  originalUrl: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.oneOf(['created', 'accepted', 'rejected']),
  onStatusChange: PropTypes.func,
  loading: PropTypes.bool,
  videoStatus: PropTypes.oneOf(['waiting', 'converting', 'finished', 'failed']),
};

MaterialCard.defaultProps = {
  mediaType: 'image',
  cover: '',
  originalUrl: '',
  url: '',
  title: '',
  status: 'created',
  onStatusChange: () => {},
  loading: false,
  videoStatus: undefined,
};


export default MaterialCard;
